import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { formatDate } from "utils/Utils";
import { removeUnderscoresAndCapitalize } from "utils/Utils";

const useStyles = makeStyles(styles);

const AcknowledgementPayment = ({ customerInfoData }) => {

  const {
    disbursalAmount,
    loanAccountNumber,
    disbursalDate,
    paymentReferenceNum,
    paymentMode,
    imagelogo,
    customerName,
    transactionBranchName,
    maker,
    companyName,
  } = customerInfoData;

  return (
    <>
      <GridContainer>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <img
            src={imagelogo}
            alt="Logo"
            width="100"
            // style={{
            //   display: "block",
            //   // marginLeft: "auto",
            //   // marginRight: "auto",
            // }}
          />
        </GridItem>
        <GridItem xs={8} sm={8} md={8} lg={8} style={{ textAlign: "start" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "1.825em",
              lineHeight: "1.5em",
            }}
          >
            {" "}
            Acknowledgement Payment
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "end", marginTop: 10 }}
        >
          <div>
            <span>{"Date: "}</span>
            <span>{formatDate(new Date())}</span>
          </div>
          <div>
            <span>{"Payment Reference Number:  "}</span>
            <span> {paymentReferenceNum}</span>
          </div>
        </GridItem>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 10 }}
        >
          <div>
            {"Paid amount of Rs." +
              disbursalAmount +
              " in " +
              " CASH towards the following"}
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          marginTop: 10,
          border: "2px solid #cccccc",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Account No</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{loanAccountNumber}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payment To</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>CUSTOMER</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Customer Name</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{customerName}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Maker</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{maker}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payemnt Purpose</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>DISBURSAL</div>
        </GridItem>
      </GridContainer>

      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payment Mode</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>CASH</div>
        </GridItem>
      </GridContainer>
      {/* <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Transaction Date</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{formatDate(txnDate)}</div>
        </GridItem>
      </GridContainer> */}
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>currency</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>INR</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Date Of Payment</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{formatDate(disbursalDate)}</div>
        </GridItem>
      </GridContainer>

      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Transaction Branch Name</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{transactionBranchName}</div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 20 }}
        >
          <div>For LMS</div>
        </GridItem>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 15 }}
        >
          <div>Authorized Person</div>
          <div>{`${removeUnderscoresAndCapitalize(companyName)} Team`}</div>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ textAlign: "start", marginTop: 15 }}>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Maker Id</div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>: {maker}</div>
        </GridItem>
        <GridItem
          xs={4}
          sm={4}
          md={4}
          lg={4}
          style={{ textAlign: "start" }}
        ></GridItem>

        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Date & Time</div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>
            {new Date().toLocaleString().slice(0, 9) +
              " " +
              new Date(new Date()).toString().split(" ")[4]}
          </div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Customer Signature</div>
        </GridItem>
      </GridContainer>
      <br />
      <br />
      <br />
      <GridContainer>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <img
            src={imagelogo}
            alt="Logo"
            width="100"
            // style={{
            //   display: "block",
            //   // marginLeft: "auto",
            //   // marginRight: "auto",
            // }}
          />
        </GridItem>
        <GridItem xs={8} sm={8} md={8} lg={8} style={{ textAlign: "start" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "1.825em",
              lineHeight: "1.5em",
            }}
          >
            {" "}
            Acknowledgement Payment
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "end", marginTop: 10 }}
        >
          <div>
            <span>{"Date: "}</span>
            <span>{formatDate(new Date())}</span>
          </div>
          <div>
            <span>{"Payment Reference Number:  "}</span>
            <span> {paymentReferenceNum}</span>
          </div>
        </GridItem>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 10 }}
        >
          <div>
            {"Paid amount of Rs." +
              disbursalAmount +
              " in " +
              " CASH towards the following"}
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          marginTop: 10,
          border: "2px solid #cccccc",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Account No</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{loanAccountNumber}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payment To</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>CUSTOMER</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Customer Name</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{customerName}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Maker</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{maker}</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payemnt Purpose</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>DISBURSAL</div>
        </GridItem>
      </GridContainer>

      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Payment Mode</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>CASH</div>
        </GridItem>
      </GridContainer>
      {/* <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Transaction Date</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{formatDate(txnDate)}</div>
        </GridItem>
      </GridContainer> */}
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>currency</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>INR</div>
        </GridItem>
      </GridContainer>
      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Date Of Payment</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{formatDate(disbursalDate)}</div>
        </GridItem>
      </GridContainer>

      <GridContainer
        style={{
          border: "2px solid #cccccc",
          borderTop: "none",
          textAlign: "left",
        }}
      >
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>Transaction Branch Name</div>
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div>{transactionBranchName}</div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 20 }}
        >
          <div>For LMS</div>
        </GridItem>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start", marginTop: 15 }}
        >
          <div>Authorized Person</div>
          <div>{`${removeUnderscoresAndCapitalize(companyName)} Team`}</div>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ textAlign: "start", marginTop: 15 }}>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Maker Id</div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>: {maker}</div>
        </GridItem>
        <GridItem
          xs={4}
          sm={4}
          md={4}
          lg={4}
          style={{ textAlign: "start" }}
        ></GridItem>

        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Date & Time</div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>
            {new Date().toLocaleString().slice(0, 9) +
              " " +
              new Date(new Date()).toString().split(" ")[4]}
          </div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div>Customer Signature</div>
        </GridItem>
      </GridContainer>
    </>
  );
};
AcknowledgementPayment.propTypes = {
  customerInfoData: PropTypes.object,
};

export default AcknowledgementPayment;
